module.exports = __webpack_public_path__ + "img/laras.ae55f3e4.jpg";